// Personalized product catalog — static config for Shine on Coin engraving products

export const CONTACT = {
  phone: "+91 7095255566",
  phoneDigits: "917095255566",
  email: "shineoncoin@gmail.com",
  whatsapp: "https://wa.me/917095255566",
  instagram: "https://instagram.com/shineoncoin",
  instagramHandle: "@shineoncoin",
  hours: "Mon–Sat, 10:00 AM – 8:00 PM",
  brandName: "Shine on Coin",
  tagline: "Personalized Gold & Silver Engravings",
  turnaround:
    "Delivery inside Hyderabad within 2–3 business days · outside Hyderabad within 4–6 business days.",
};

// Real product photos — Shine on Coin silver photo-coin range
const PHOTOS = {
  // ── Product 1 · 30g flower-CZ silver coin ──
  silverCoin30gPrimary:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/fuu8zzyx_WhatsApp%20Image%202026-07-30%20at%2015.03.45.jpg",
  silverCoin30gSecondary:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/sahxjj85_WhatsApp%20Image_2026-07-30%20at%2015.03.46.jpg",
  silverCoin30gLifestyle:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/k60gr9nb_WhatsApp%20Image%202026-07-30%20at%2015.03.46.jpg",
  silverCoin30gCoupleA:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/6oq0vlmp_WhatsApp__Image%202026-07-30%20at%2015.03.48.jpg",
  silverCoin30gPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/pjza4vji_WhatsApp%20Image%202026-07-30%20at%2015.03.48.webp",
  silverCoin30gCommemorative:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/zbqmvchx_WhatsApp_Image%202026-07-30%20at%2015.03.48.webp",
  silverCoin30gAnniv25:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ohnyv4ax_WhatsApp_Image%202026-07-30%20at%2015.03.46.jpg",
  silverCoin30gCommemorative:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/9qixrbu1_WhatsApp%20Image%202026-07-30%20at%2015.03.48.webp",

  // ── Product 2 · 30g / 51mm plain-CZ silver coin in 140×90 acrylic frame ──
  silverCoin51mmWedding:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/b9e6v37s_WhatsApp%20Image%202026-07-30%20at%2014.55.10.jpg",
  silverCoin51mmBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/mvlx8g40_WhatsApp%20Image%202026-07-30%2014.57.07.jpg",
  silverCoin51mmAnniversary:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/yxwiybh3_WhatsApp%20Image%202026-07-30%20at%2014.55.10%20%281%29.webp",
  silverCoin51mmBlessings:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/t4zk3q46_WhatsApp%20Image%202026-07-30%20at%2014.55.09.jpg",
  silverCoin51mmDoctor:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/8h3jvi7c_WhatsApp%20Image%202026-07-30%20at%2014.55.09%20%281%29.jpg",

  // ── Product 3 · 10g / 32mm plain-CZ silver coin in 110×70 acrylic frame ──
  silverCoin32mmAnniversary:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/hukoh51t_WhatsApp%20Image%202026-07-30%20at%2015.18.18.jpeg",
  silverCoin32mmChiefGuest:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/d0bzr81v_WhatsApp%20Image%202026-07-30%20at%2015.18.19.jpeg",
  silverCoin32mmBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/qseo7hc1_WhatsApp%20Image%202026-07-30%20at%2015.18.20.jpeg",
  silverCoin32mm60th:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/gcti44wz_WhatsApp%20Image%202026-07-30%20at%2015.18.21.jpeg",
  silverCoin32mmCorporate:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/j5i2pvo2_WhatsApp%20Image%202026-07-30%20at%2015.18.22.jpeg",
  // Additional 10g / 32mm variants — flower-CZ ring
  silverCoin32mmMinister:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/aaaz2ye2_WhatsApp%20Image%202026-07-30%20at%2015.37.43.jpeg",
  silverCoin32mmMaharaj:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/nycy367a_WhatsApp%20Image%202026-07-30%20at%2015.37.45.jpeg",
  silverCoin32mmWedding:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ioxbyyre_WhatsApp%20Image%202026-07-30%20at%2015.37.47.jpeg",
  silverCoin32mmReturns:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/atp7jw9a_WhatsApp%20Image%202026-07-30%20at%2015.37.49.webp",
  silverCoin32mm25thAnniv:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/5vpujri9_WhatsApp_Image%202026-07-30%20at%2015.37.45.jpeg",

  // ── Product 4 · 5g floating-display silver coin (four shapes) ──
  silverCoin5gHeartBlack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/isgwa2sq_WhatsApp_Image%202026-08-01%20at%2014.52.31.jpeg",
  silverCoin5gOvalPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/i4dl630x_WhatsApp%20Image%202026-08-01%20at%2014.52.32.webp",
  silverCoin5gOvalBlue:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/emikze0h_WhatsApp_Image%202026-08-01%20at%2014.54.45.jpeg",
  silverCoin5gHeartCream:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/forcv55c_WhatsApp%20Image%202026-08-01%20at%2015.00.22.jpeg",
  silverCoin5gRoundTrio:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/4rsohtuq_WhatsApp%20Image%202026-08-01%20at%2015.00.21.jpeg",
  // Extended floating-frame variants — round & square coins, 5g–100g weight range
  silverCoinFloatDiamondRoundA:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/kvjdcsku_WhatsApp%20Image%202026-07-31%20at%2019.32.02.jpeg",
  silverCoinFloatDiamondRoundB:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ipeva7ln_WhatsApp%20Image%202026-07-31%20at%2019.32.03.jpeg",
  silverCoinFloatSquareBlack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/0e9wto4p_WhatsApp%20Image%202026-07-31%20at%2019.39.45.jpeg",
  silverCoinFloatSquareWhite:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ro0fdmrn_WhatsApp%20Image%202026-07-31%20at%2019.39.47.jpeg",
  silverCoinFloatDiamondSquare:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/f98942ok_WhatsApp%20Image%202026-07-31%20at%2019.39.48.webp",
  silverCoinFloatCoinBack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ox3ylu2u_WhatsApp%20Image%202026-07-31%20at%2019.39.51.webp",
  silverCoinFloatCorporateLogo:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ue3so8u2_WhatsApp%20Image%202026-07-31%20at%2019.42.15.webp",
  silverCoinFloatPortraitBW:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ih3sbix8_WhatsApp%20Image%202026-07-31%20at%2019.42.14.jpeg",
  silverCoinFloatCoupleClose:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xptf67mf_WhatsApp_Image%202026-07-31%20at%2019.42.15.jpeg",
  // 30g floating round-coin batch — CZ ring in circular 3D floating stand
  silverCoinFloat30gCongrats:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/3uyrj9m9_WhatsApp%20Image%202026-07-31%20at%2019.18.18.jpeg",
  silverCoinFloat30gRoundPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/kta53t2a_WhatsApp%20Image%202026-07-31%20at%2019.27.25.jpeg",
  silverCoinFloat30gRailways:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/zc3rdy8f_WhatsApp%20Image%202026-07-31%20at%2019.27.26.jpeg",
  silverCoinFloat30gJourney60:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/uervqfdy_WhatsApp__Image%202026-07-31%20at%2019.27.26.jpeg",
  silverCoinFloat30gCoupleBW:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/j5vlg62a_WhatsApp___Image%202026-07-31%20at%2019.27.26.jpeg",
  // 30g round-coin floating frame — extra samples batch B
  silverCoinFloat30gPortraitB:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/dlkzl4bw_WhatsApp_Image%202026-07-31%20at%2019.32.01.jpeg",
  silverCoinFloat30gPortraitC:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/otaz4enr_WhatsApp_Image%202026-07-31%20at%2019.27.26.jpeg",
  silverCoinFloat30gBaby:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/m81eeqik_WhatsApp_Image%202026-07-31%20at%2019.18.19.jpeg",
  silverCoinFloat30gCoupleD:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/pye020ii_WhatsApp_Image%202026-07-31%20at%2019.18.18.jpeg",
  silverCoinFloat30gCoupleE:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/buujvwwq_WhatsApp__Image%202026-07-31%20at%2019.27.26.jpeg",

  // ── Product 7 · 100g silver plate momento in dome-topped acrylic vault ──
  silverPlateMomentoWedding:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/2p2e1ofq_WhatsApp%20Image%202026-07-31%20at%2018.13.35.jpeg",
  silverPlateMomento25thAnniv:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/e8d1mxgd_WhatsApp%20Image%202026-07-31%20at%2018.13.34.jpeg",
  silverPlateMomentoMarriedLife:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/mi2vkuso_WhatsApp%20Image%202026-07-31%20at%2018.13.33.jpeg",
  silverPlateMomentoCradle:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/nlojyg4u_WhatsApp%20Image%202026-07-31%20at%2018.06.23.jpeg",
  silverPlateMomentoFamily:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/jmyq33dh_WhatsApp%20Image%202026-07-31%20at%2018.06.22.jpeg",
  // Silver plate momento — batch B (corporate, milestone anniversaries, birthday, family)
  silverPlateMomentoBoxing:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/pxwwqf4u_WhatsApp_Image%202026-07-31%20at%2019.06.18.jpeg",
  silverPlateMomento25thHearts:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ifp4mb76_WhatsApp_Image%202026-07-31%20at%2019.06.16.jpeg",
  silverPlateMomento25thFamily:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/wp58nuvt_WhatsApp_Image%202026-07-31%20at%2018.13.36.jpeg",
  silverPlateMomentoMemoriesForever:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/bdfubq3a_WhatsApp_Image%202026-07-31%20at%2018.13.35.jpeg",
  silverPlateMomento50thBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/l0qgppsu_WhatsApp_Image%202026-07-31%20at%2018.06.23.jpeg",
  // Silver plate momento — batch C (corporate silver jubilee, wedding Hindi, beach couple, doctor thank you, 60th birthday)
  silverPlateMomentoSilverJubilee:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/8lbswvkv_WhatsApp__Image%202026-07-31%20at%2018.06.22.jpeg",
  silverPlateMomentoWeddingHindi:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/7ig7hspa_WhatsApp%20Image%202026-07-31%20at%2019.06.17.jpeg",
  silverPlateMomentoBeachCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/8wxo64ac_WhatsApp%20Image%202026-07-31%20at%2019.06.16.jpeg",
  silverPlateMomentoDoctorThank:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/rvxtx80u_WhatsApp%20Image%202026-07-31%20at%2018.13.38.webp",
  silverPlateMomento60thBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/1gzbahll_WhatsApp%20Image%202026-07-31%20at%2018.13.37.jpeg",

  // ── Product 8 · Silver Square Photo Coin — Tombstone Plaque (10g 30mm / 20g 37mm) ──
  silverSquareTombstoneBirthdaySir:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/cjuro3m8_WhatsApp_Image%202026-07-30%20at%2015.52.38.jpeg",
  silverSquareTombstoneNewAbode:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/okgfqv8h_WhatsApp_Image%202026-07-30%20at%2015.52.37.jpeg",
  silverSquareTombstoneHappyBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/e3xpqv60_WhatsApp__Image%202026-07-30%20at%2015.52.37.jpeg",
  silverSquareTombstoneDiva25:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/zw4p57o5_WhatsApp%20Image%202026-07-30%20at%2015.52.38.webp",
  silverSquareTombstoneHarshPrachi:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/5wvyo2zq_WhatsApp%20Image%202026-07-30%20at%2015.52.37.jpeg",

  // ── Product 9 · Imported mesh & Rolex-style stretch belts with 18k gold nameplate ──
  goldStretchBraceletMJD:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ocxtllic_WhatsApp%20Image%202026-08-01%20at%2016.13.13.jpeg",
  goldStretchBraceletViraj:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/b6mdv29a_WhatsApp%20Image%202026-08-01%20at%2016.13.12.jpeg",
  goldStretchBraceletSymbols:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/br6n0670_WhatsApp%20Image%202026-08-01%20at%2016.12.12.webp",
  goldStretchBraceletInitialStack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/qecyav9s_WhatsApp%20Image%202026-08-01%20at%2016.12.11.webp",
  goldStretchBraceletRolexInitials:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/fqe46e7t_WhatsApp%20Image%202026-08-01%20at%2016.12.10.webp",
  // Gold nameplate stretch bracelet — batch B (blue rolex triple initials, black rolex Mohit, brown/blue A+M CZ, full 18ct gold mesh, brown rolex knot CZ)
  goldStretchBraceletBlueInitialsTrio:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/diiv33pw_WhatsApp%20Image%202026-08-01%20at%2016.14.40.jpeg",
  goldStretchBraceletMohit:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/bh56x6b2_WhatsApp%20Image%202026-08-01%20at%2016.14.41.jpeg",
  goldStretchBraceletMeshAM:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/gu7qq2lv_WhatsApp%20Image%202026-08-01%20at%2016.13.15.jpeg",
  goldStretchBraceletFullGoldChevron:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/z3nir1m6_WhatsApp%20Image%202026-08-01%20at%2016.16.03.webp",
  goldStretchBraceletBrownKnot:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/2eckfx68_WhatsApp%20Image%202026-08-01%20at%2016.16.02.webp",
  // Gold nameplate stretch bracelet — batch C (Greek-key nameplates, 7-belt initial stack, colour swatch stack, ornate R medallion, N circular CZ)
  goldStretchBraceletGreekKeyMSDSRS:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/dzmgj8eb_WhatsApp_Image%202026-08-01%20at%2016.12.11.webp",
  goldStretchBraceletGoldInitialStack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/j5oiw17v_WhatsApp_Image%202026-08-01%20at%2016.12.10.webp",
  goldStretchBraceletColourSwatch:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/86dhjnsc_WhatsApp%20Image%202026-08-01%20at%2016.16.06.webp",
  goldStretchBraceletOrnateR:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/4s7nqwed_WhatsApp%20Image%202026-08-01%20at%2016.16.05.webp",
  goldStretchBraceletCircularN:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/yiemld0e_WhatsApp%20Image%202026-08-01%20at%2016.16.04.webp",
  // Gold nameplate stretch bracelet — batch D (Om CZ on navy rolex, black SMASP stack, Superman-shield initials, gold mesh CZ centrepiece stack)
  goldStretchBraceletOmNavy:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/gf9kawpv_WhatsApp_Image%202026-08-01%20at%2016.14.41.jpeg",
  goldStretchBraceletBlackSMASP:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/qouoz4jw_WhatsApp_Image%202026-08-01%20at%2016.14.40.jpeg",
  goldStretchBraceletSupermanShield:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/b2omp4re_WhatsApp_Image%202026-08-01%20at%2016.13.13.jpeg",
  goldStretchBraceletGoldCZStack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/9dcsme9o_WhatsApp_Image%202026-08-01%20at%2016.16.04.webp",

  // ── Product 10 · 100g / 75mm grand tombstone plaque with flower CZ ring ──
  silverCoin100gFinecabPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/3c72srs4_WhatsApp_Image%202026-07-29%20at%2015.12.48.webp",
  silverCoin100gKCR:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xinsgyda_WhatsApp__Image%202026-07-29%20at%2015.12.48.webp",
  silverCoin100gElder:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xibnx0lk_WhatsApp__Image%202026-07-29%20at%2015.12.46.jpeg",
  silverCoin100gTurbanCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/novv892x_WhatsApp%20Image%202026-07-29%20at%2015.12.47.webp",

  // Product 10 · 100g Grand Tombstone — batch B
  silverCoin100gSharda:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/he0x50s3_WhatsApp%20Image%202026-07-29%20at%2015.12.49.webp",
  silverCoin100gPremaManihar:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/0gmqiraa_WhatsApp%20Image%202026-07-29%20at%2015.12.46.jpeg",
  silverCoin100gIronMan:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/tjgbnwg3_WhatsApp%20Image%202026-07-29%20at%2015.12.45.jpeg",
  silverCoin100gLoyaFamily:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/fba5wolw_WhatsApp%20Image%202026-07-29%20at%2015.12.44.jpeg",
  // ── Product 6 · 22ct gold engraved photo locket (heart / oval / shield / round) ──
  goldLocketShield:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ssi92756_WhatsApp_Image%202026-08-01%20at%2015.05.32.jpeg",
  goldLocketOvalCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/t4w1mci1_WhatsApp__Image%202026-08-01%20at%2015.05.32.jpeg",
  goldLocketOvalPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/mtp1hlvk_WhatsApp%20Image%202026-08-01%20at%2015.05.33.webp",
  goldLocketHeart:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/rmzorz73_WhatsApp%20Image%202026-08-01%20at%2015.05.32.jpeg",
  goldLocketRoundWoman:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/g02u4ofh_WhatsApp%20Image%202026-08-01%20at%2014.57.28.jpeg",

  // ── Product 5 · Multi-coin arched acrylic momento (customisable frame colour) ──
  archedMomentoBlack3:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/1m6ruo1t_WhatsApp%20Image%202026-08-01%20at%2015.12.10.jpeg",
  archedMomentoBlack6:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/408f45tr_WhatsApp%20Image%202026-08-01%20at%2015.12.11.jpeg",
  archedMomentoBrushedGold4:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/75qdg1oe_WhatsApp%20Image%202026-08-01%20at%2015.12.12.jpeg",
  archedMomentoOlive4:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/jwz7w8ox_WhatsApp%20Image%202026-08-01%20at%2015.12.13.jpeg",
  archedMomentoMocha4:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/oyufqs6k_WhatsApp%20Image%202026-08-01%20at%2015.12.14.jpeg",
  // Extended shape / configuration variants
  archedMomentoCircular12:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/nh057vnw_WhatsApp%20Image%202026-08-01%20at%2015.12.16.jpeg",
  archedMomentoTallVertical14:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ca6n7c0o_WhatsApp%20Image%202026-08-01%20at%2015.12.15.jpeg",
  archedMomentoClassic5:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/p7kkiyco_WhatsApp__Image%202026-08-01%20at%2015.12.17.jpeg",
  archedMomentoTwinArch2:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/2fa4zo9l_WhatsApp_Image%202026-08-01%20at%2015.12.16.jpeg",
  archedMomentoTemple4:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/l3ttb9f8_WhatsApp_Image%202026-08-01%20at%2015.12.15.jpeg",
  // Product 5 arched momento — batch F (Prashe 1st birthday, Diamond 60th, 25th Di n Jiju, 25th 5-coin, Diwali 2020 twin)
  archedMomentoPrashe1stBirthday:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ig82ulf1_WhatsApp_Image%202026-08-01%20at%2015.12.17.webp",
  archedMomentoDiamond60thTall:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/x82wri1p_WhatsApp_Image%202026-08-01%20at%2015.12.15.jpg",
  archedMomento25thDiJiju:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/83ed207g_WhatsApp__Image%202026-08-01%20at%2015.12.17.jpg",
  archedMomento25thWeddingFive:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/2e0jg0ez_WhatsApp%20Image%202026-08-01%20at%2015.12.16.jpg",
  archedMomentoDiwali2020Twin:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/7xmtjgfz_WhatsApp%20Image%202026-08-01%20at%2015.12.17.webp",
  // Product 5 arched momento — batch G (Shat Shat Naman temple, Wish Wedding Anniversary 3-coin)
  archedMomentoShatShatNaman:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/a7gxb3zq_WhatsApp_Image%202026-08-01%20at%2015.12.16.jpg",
  archedMomentoWishWeddingThree:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ji7p409a_WhatsApp%20Image%202026-08-01%20at%2015.12.15.jpg",
  // Product 6 gold locket — refreshed set (shield woman, oval boy, oval couple, oval mustache man, heart couple, round woman)
  goldLocketShieldWoman:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ymc0lerm_WhatsApp%20Image%202026-08-01%20at%2015.05.31.jpg",
  goldLocketOvalBoy:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/1770xb0j_WhatsApp_Image%202026-08-01%20at%2015.05.32.jpg",
  goldLocketOvalCoupleGold:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/avf6ht5k_WhatsApp__Image%202026-08-01%20at%2015.05.32.jpg",
  goldLocketOvalMustacheChain:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/elqlqjv1_WhatsApp%20Image%202026-08-01%20at%2015.05.32.jpg",
  goldLocketHeartCoupleGold:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/aj4s1474_WhatsApp%20Image%202026-08-01%20at%2015.05.33.webp",
  goldLocketRoundWomanGold:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/e61b1ss5_WhatsApp%20Image%202026-08-01%20at%2014.57.28.jpg",
  // Product 7 silver plate momento — refreshed set (bearded couple, retro couple, kanchana couple, family of three, family of six)
  silverPlateMomentoCoupleBearded:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/q0ooud1k_WhatsApp%20Image%202026-07-31%20at%2018.13.35.jpg",
  silverPlateMomentoCoupleRetro:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/0exoqdlz_WhatsApp%20Image%202026-07-31%20at%2018.13.34.jpg",
  silverPlateMomentoCoupleKanchana:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/mj8gj0do_WhatsApp%20Image%202026-07-31%20at%2018.13.33.jpg",
  silverPlateMomentoFamilyThree:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/wxwshpef_WhatsApp%20Image%202026-07-31%20at%2018.06.23.jpg",
  silverPlateMomentoFamilySix:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/f6hzpq2b_WhatsApp%20Image%202026-07-31%20at%2018.06.22.jpg",
  // Product 7 silver plate momento — batch B (young couple pink+blue, three-men red backdrop, young couple beard+glasses, beach couple, yellow-saree portrait)
  silverPlateMomentoYoungCouplePink:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/3thn69gz_WhatsApp%20Image%202026-07-31%20at%2019.06.17.jpg",
  silverPlateMomentoThreeMen:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/0lugo8ee_WhatsApp%20Image%202026-07-31%20at%2019.06.16.jpg",
  silverPlateMomentoBeardGlassesCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/28val4nd_WhatsApp%20Image%202026-07-31%20at%2018.13.37.jpg",
  silverPlateMomentoBeachCoupleNew:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/o50cjo5l_WhatsApp%20Image%202026-07-31%20at%2018.13.38.webp",
  silverPlateMomentoYellowSaree:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/y2wk9jiu_WhatsApp%20Image%202026-07-31%20at%2018.13.36.jpg",
  // Product 7 silver plate momento — batch C (Boxing champion, 25th anniv hearts, 50th birthday)
  silverPlateMomentoBoxingChampion:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/myfdq2j1_WhatsApp_Image%202026-07-31%20at%2019.06.18.jpg",
  silverPlateMomento25thHeartsNew:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/3z3zbvec_WhatsApp_Image%202026-07-31%20at%2019.06.16.jpg",
  silverPlateMomento50thBirthdayNew:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/shs4kehk_WhatsApp_Image%202026-07-31%20at%2018.13.36.jpg",
  // Product 9 gold nameplate bracelet — refreshed set (S/M/A/S/P mesh, AC/HG/GC/SG ornate, MRASRK stack, religious motifs, MJD wide monogram)
  goldStretchBraceletSMASPMesh:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/dxy4fkx0_WhatsApp%20Image%202026-08-01%20at%2016.12.11.webp",
  goldStretchBraceletOrnateMonograms:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xbospk12_WhatsApp%20Image%202026-08-01%20at%2016.12.10.webp",
  goldStretchBraceletMRASRKStack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/f2stzuji_WhatsApp%20Image%202026-08-01%20at%2016.13.12.jpg",
  goldStretchBraceletReligiousMotifs:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/7ebvldz5_WhatsApp%20Image%202026-08-01%20at%2014.50.54.jpg",
  goldStretchBraceletMJDWide:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/7nsu41wi_WhatsApp%20Image%202026-08-01%20at%2016.12.12.webp",
  // Product 9 gold nameplate bracelet — batch B (Viraj CZ monogram, K/AK/LK trio, Mohit shield, A+M two-mesh, rose-gold chevron)
  goldStretchBraceletVirajNavy:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/p094yg36_WhatsApp%20Image%202026-08-01%20at%2016.13.13.jpg",
  goldStretchBraceletBlueKAKLK:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/nrub51qn_WhatsApp%20Image%202026-08-01%20at%2016.13.15.jpg",
  goldStretchBraceletMohitShield:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/iyf44mmj_WhatsApp%20Image%202026-08-01%20at%2016.14.40.jpg",
  goldStretchBraceletBrownATwoMesh:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/iy9nj09a_WhatsApp%20Image%202026-08-01%20at%2016.14.41.jpg",
  goldStretchBraceletRoseGoldChevron:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/td63e0eg_WhatsApp%20Image%202026-08-01%20at%2016.16.02.webp",
  // Product 9 gold nameplate bracelet — batch C (choc heart knot, gold N mesh, black R ornate, 5-mesh belt stack, S/A/M diamond shields)
  goldStretchBraceletChocHeartKnot:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/br6n0670_WhatsApp%20Image%202026-08-01%20at%2016.12.12.webp",
  goldStretchBraceletGoldNCircle:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/j5oiw17v_WhatsApp_Image%202026-08-01%20at%2016.12.10.webp",
  goldStretchBraceletBlackROrnate:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/dzmgj8eb_WhatsApp_Image%202026-08-01%20at%2016.12.11.webp",
  goldStretchBraceletFiveMeshStack:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/4s7nqwed_WhatsApp%20Image%202026-08-01%20at%2016.16.05.webp",
  goldStretchBraceletDiamondShields:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/9dcsme9o_WhatsApp_Image%202026-08-01%20at%2016.16.04.webp",
  // Product 9 gold nameplate bracelet — batch D (MRAASRK 7-stack, MS/DS Greek-key duo, Om navy CZ, 4-stack CZ pendants)
  goldStretchBraceletMRAASRKSeven:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/vebjthsp_WhatsApp_Image%202026-08-01%20at%2016.12.11.webp",
  goldStretchBraceletBrownMSDS:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/enp5dy5z_WhatsApp_Image%202026-08-01%20at%2016.12.10.webp",
  goldStretchBraceletOmNavyCZ:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/betxx9qj_WhatsApp_Image%202026-08-01%20at%2016.13.13.jpg",
  goldStretchBraceletGoldMeshCZFour:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xf0c8cja_WhatsApp_Image%202026-08-01%20at%2016.16.04.webp",
  // Product 10 grand tombstone — extra (RamGopal & Sharmila Kedia wedding anniversary couple)
  silverCoin100gKediaWedding:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xnvcrkrk_WhatsApp%20Image%202026-07-29%20at%2015.12.47.webp",
  // Product 3 compact frame — refreshed tombstone-plaque set (25th anniv couple, Sudha Reddy, Vedaant 1st birthday, Lata Srinivasan 60th, Charbhuja Marbles)
  silverCoin32mm25thCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/grfvkqde_WhatsApp%20Image%202026-07-30%20at%2015.18.22.jpg",
  silverCoin32mmSudhaReddy:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/dyj3327d_WhatsApp%20Image%202026-07-30%20at%2015.18.21.jpg",
  silverCoin32mmVedaant1st:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ge07pxxv_WhatsApp%20Image%202026-07-30%20at%2015.18.20.jpg",
  silverCoin32mmLata60:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/17u3u3f0_WhatsApp%20Image%202026-07-30%20at%2015.18.19.jpg",
  silverCoin32mmCharbhuja:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/uvcguiho_WhatsApp%20Image%202026-07-30%20at%2015.18.18.jpg",
  // Product 3 compact frame — extra batch (Married Life couple, Happy Returns portrait, Wedding Anniversary couple, Krish Sanitation logo, 25th Anniversary couple)
  silverCoin32mmMarriedLife:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/xpq1j99a_WhatsApp%20Image%202026-07-30%20at%2015.37.43.jpg",
  silverCoin32mmHappyReturns:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/gqp9lj1j_WhatsApp%20Image%202026-07-30%20at%2015.37.45.jpg",
  silverCoin32mmLifetimeAnniv:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/d32n8rvx_WhatsApp%20Image%202026-07-30%20at%2015.37.47.jpg",
  silverCoin32mmKrishSanitation:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/k0fpv9hv_WhatsApp%20Image%202026-07-30%20at%2015.37.49.webp",
  silverCoin32mm25AnnivCouple:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/cwmm0ue2_WhatsApp%20Image%202026-07-30%20at%2015.37.50.jpg",

  // ── Birthday occasion refresh — reference photos for occasion card + 4 mapped products ──
  birthdayTombstoneVedaantRef:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/op5v7i6v_WhatsApp%20Image%202026-07-30%20at%2015.18.20.jpg",
  anniversaryOvalFrameCoupleRef:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/jacv3vk6_WhatsApp%20Image%202026-07-31%20at%2019.06.16.jpg",
  achievementsIronManTrophyRef:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/4yu7zglb_WhatsApp%20Image%202026-07-29%20at%2015.12.46.jpg",
  birthdayGoldCoinFrameRef:
    "https://shineoncoin.com/api/files/dov-creations/uploads/14847f4d-3d03-47b6-8779-f5dea5ac7f01.jpg",
  birthdaySilverPlateOvalRef:
    "https://shineoncoin.com/api/files/dov-creations/uploads/4a01e509-7c92-4114-b067-11b1505afeae.jpg",
  birthdayBraceletInitialsRef:
    "https://shineoncoin.com/api/files/dov-creations/uploads/3f332ab5-451b-4fc2-86b1-82df7d7ab34b.jpg",
  birthdayTwinStandRef:
    "https://shineoncoin.com/api/files/dov-creations/uploads/6a035d5d-d4b7-4603-b262-1a9309d1cfe0.jpg",
};

export const HERO_IMAGE = PHOTOS.silverCoin30gPrimary;
export const HERO_ACCENT_IMAGE = PHOTOS.silverCoin51mmWedding;

// Featured hero products (highlighted at the top of the page)
export const HERO_FEATURED = [
  {
    id: "silver-photo-coin-30g",
    designNumber: "05",
    image: PHOTOS.silverCoin30gPortrait,
    title: "Flower CZ · Piano-Black Stand",
    caption: "30 g · 99.9 Silver Coin",
  },
  {
    id: "gold-nameplate-stretch-bracelet",
    designNumber: "18",
    image: PHOTOS.goldStretchBraceletOmNavyCZ,
    title: "Stretch Belt · Gold Nameplate",
    caption: "18 ct Gold · Daily Wear",
  },
];

// Retained for backwards compatibility with ConfiguratorDialog (unused with current catalog)
export const SHAPE_PLACEHOLDERS = {};

export const HERO_BACKDROP =
  "https://images.unsplash.com/photo-1705674337411-3b89e5afcc11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbHV4dXJ5JTIwc2lsayUyMGZhYnJpYyUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg1MzE1OTc1fDA&ixlib=rb-4.1.0&q=85&w=1600";

export const PERSONALIZED_PRODUCTS = [
  {
    id: "silver-photo-coin-30g",
    name: "Photo Engraved Silver Coin — 30g",
    tag: "99.9 Silver · Flower CZ",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "flower-cz-piano-black",
    designLabel: "Flower CZ · Piano-Black Stand",
    weights: ["30g"],
    blurb:
      "A 30-gram 99.9 pure silver coin, hand-engraved with your photograph and framed by a floral border of cubic zirconia stones — presented on a piano-black acrylic stand with your custom message engraved beneath.",
    image: PHOTOS.silverCoin30gPrimary,
    secondaryImage: PHOTOS.silverCoin30gSecondary,
    gallery: [
      PHOTOS.silverCoin30gPrimary,
      PHOTOS.silverCoin30gSecondary,
      PHOTOS.silverCoin30gLifestyle,
      PHOTOS.silverCoin30gCoupleA,
      PHOTOS.silverCoin30gPortrait,
      PHOTOS.silverCoin30gAnniv25,
    ],
    highlights: [
      "30g solid coin · 99.9 fine silver",
      "Cubic zirconia flower stone border",
      "Piano-black acrylic display stand",
      "Custom photo + two-line engraving",
    ],
    options: {
      weight: ["30g (99.9)"],
      stand: ["Piano-Black Acrylic"],
    },
    fields: {
      photo: true,
      messageLine1: { label: "Engraving line 1 (max 10 words)", maxWords: 10 },
      messageLine2: { label: "Engraving line 2 — names (max 6 words)", maxWords: 6 },
    },
  },
  {
    id: "silver-photo-coin-51mm",
    name: "Photo Engraved Silver Coin — 30gr",
    tag: "99.9 Silver · 140×90 Frame",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "round-cz-140x90-frame",
    designLabel: "Round CZ · 140×90 Acrylic Frame",
    weights: ["30g"],
    blurb:
      "A 30-gram 99.9 fine silver coin (51 mm) set with a shimmering ring of cubic zirconia stones, mounted inside a 140 × 90 × 9 mm transparent acrylic frame — with up to six words engraved on the coin's back and eight words on the frame.",
    image: PHOTOS.silverCoin51mmWedding,
    secondaryImage: PHOTOS.silverCoin51mmAnniversary,
    gallery: [
      PHOTOS.silverCoin51mmWedding,
      PHOTOS.silverCoin51mmAnniversary,
      PHOTOS.silverCoin51mmBirthday,
      PHOTOS.silverCoin51mmBlessings,
      PHOTOS.silverCoin51mmDoctor,
    ],
    highlights: [
      "30g · 99.9 silver · 51 mm coin",
      "Double-row cubic zirconia stone ring",
      "140 × 90 × 9 mm transparent acrylic frame",
      "Up to 6 words on coin back + 8 words on frame",
    ],
    options: {
      weight: ["30g (99.9) · 51mm"],
      frame: ["Transparent Acrylic 140×90×9mm"],
    },
    fields: {
      photo: true,
      coinBackText: { label: "Coin back engraving (max 6 words)", maxWords: 6 },
      frameText: { label: "Frame engraving (max 8 words)", maxWords: 8 },
    },
  },
  {
    id: "silver-photo-coin-10g",
    name: "Photo Engraved Silver Coin — 10 & 20gr",
    tag: "99.9 Silver · 110×70 Frame",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "round-cz-110x70-frame",
    designLabel: "Round CZ · 110×70 Compact Frame",
    weights: ["10g"],
    blurb:
      "A 10-gram 99.9 fine silver coin (32 mm) circled with cubic zirconia stones and set inside a slim 110 × 70 × 9 mm transparent acrylic frame — a lighter keepsake with up to four words on the coin's back and four words on the frame.",
    image: PHOTOS.birthdayGoldCoinFrameRef,
    secondaryImage: PHOTOS.silverCoin32mmAnniversary,
    gallery: [
      PHOTOS.birthdayGoldCoinFrameRef,
      PHOTOS.silverCoin32mm25thCouple,
      PHOTOS.silverCoin32mmSudhaReddy,
      PHOTOS.silverCoin32mmVedaant1st,
      PHOTOS.silverCoin32mmLata60,
      PHOTOS.silverCoin32mmCharbhuja,
      PHOTOS.silverCoin32mmMarriedLife,
      PHOTOS.silverCoin32mmHappyReturns,
      PHOTOS.silverCoin32mmLifetimeAnniv,
      PHOTOS.silverCoin32mmKrishSanitation,
      PHOTOS.silverCoin32mm25AnnivCouple,
    ],
    highlights: [
      "10g · 99.9 silver · 32 mm coin",
      "Plain or flower cubic zirconia stone ring",
      "110 × 70 × 9 mm transparent acrylic frame",
      "Up to 4 words on coin back + 4 words on frame",
    ],
    options: {
      weight: ["10g (99.9) · 32mm"],
      frame: ["Transparent Acrylic 110×70×9mm"],
    },
    fields: {
      photo: true,
      coinBackText: { label: "Coin back engraving (max 4 words)", maxWords: 4 },
      frameText: { label: "Frame engraving (max 4 words)", maxWords: 4 },
    },
  },
  {
    id: "silver-photo-coin-5g-float",
    name: "Photo Engraved Silver Coin on 3D Floating Frame — Various Sizes",
    tag: "99.9 Silver · 5g – 100g Range",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "floating-3d-frame",
    designLabel: "3D Floating Frame",
    weights: ["5g", "10g", "20g", "30g", "100g"],
    blurb:
      "A 99.9 fine silver coin — engraved with your photograph and framed by two shimmering rows of cubic zirconia stones — suspended inside a 3D transparent floating display stand. Available in five weights (5g, 10g, 20g, 30g, 100g), round or square coin shapes, four decorative silhouettes and multiple frame colours. A short personal message is engraved on the reverse of the coin.",
    image: PHOTOS.silverCoinFloatSquareBlack,
    secondaryImage: PHOTOS.silverCoinFloatDiamondRoundA,
    gallery: [
      // Batch B — replace-set for floating frame 5g–100g range
      PHOTOS.silverCoinFloatDiamondRoundA,
      PHOTOS.silverCoinFloat30gCongrats,
      PHOTOS.silverCoinFloat30gRoundPortrait,
      PHOTOS.silverCoinFloat30gRailways,
      PHOTOS.silverCoinFloat30gCoupleBW,
      // Batch C — added variants
      PHOTOS.silverCoinFloat30gJourney60,
      PHOTOS.silverCoinFloat30gPortraitB,
      PHOTOS.silverCoinFloat30gBaby,
      PHOTOS.silverCoinFloat30gCoupleD,
      PHOTOS.silverCoinFloat30gPortraitC,
      // Batch D — final additions
      PHOTOS.silverCoinFloat30gCoupleE,
      PHOTOS.silverCoinFloatDiamondRoundB,
      PHOTOS.silverCoinFloatSquareBlack,
      // Batch E — appended trio (elderly couple portrait, single man portrait, square-open couple frame)
      PHOTOS.silverCoinFloatCoupleClose,
      PHOTOS.silverCoinFloatPortraitBW,
      PHOTOS.silverCoinFloatSquareWhite,
    ],
    highlights: [
      "99.9 fine silver · 5g / 10g / 20g / 30g / 100g",
      "Round or square coin · four decorative shapes",
      "Two rows of cubic zirconia stones",
      "3D transparent floating display stand",
    ],
    options: {
      weight: ["5g", "10g", "20g", "30g", "100g"],
      shape: [
        "Round · 24 × 24 mm",
        "Square",
        "Oval · 27 × 20 mm",
        "Heart · 22.5 × 26.7 mm",
        "Triangle · 25 × 25 mm",
      ],
      frameColor: ["Black Diamond", "Black Square", "White", "Blue", "Cream / Rose"],
    },
    fields: {
      photo: true,
      coinBackText: { label: "Coin back engraving (max 6 words)", maxWords: 6 },
    },
  },
  {
    id: "arched-multi-coin-momento",
    name: "Multi-Coin Arched Acrylic Frame",
    tag: "Family Plaque · Custom Colour",
    productType: "momento",
    productTypeLabel: "Momento",
    designType: "arched-multi-coin",
    designLabel: "Arched Multi-Coin Momento",
    weights: ["multi"],
    blurb:
      "A premium acrylic momento — hand-set with two to fourteen 99.9-silver photo-engraved coins (each ringed with cubic zirconia stones) and finished with a personalised engraving on the base. Available in five silhouettes (Classic Arch, Twin Arch, Circular, Temple Dome, Tall Vertical) and four signature frame finishes for weddings, milestone birthdays, anniversaries and corporate honours.",
    image: PHOTOS.birthdayTwinStandRef,
    secondaryImage: PHOTOS.archedMomentoBrushedGold4,
    gallery: [
      PHOTOS.birthdayTwinStandRef,
      // Batch F — now leading (previously designs 6-10)
      PHOTOS.archedMomentoPrashe1stBirthday,
      PHOTOS.archedMomentoDiamond60thTall,
      PHOTOS.archedMomento25thDiJiju,
      PHOTOS.archedMomento25thWeddingFive,
      PHOTOS.archedMomentoDiwali2020Twin,
      // Batch G — mid
      PHOTOS.archedMomentoShatShatNaman,
      PHOTOS.archedMomentoWishWeddingThree,
      // Batch E — moved to the end (per user request)
      PHOTOS.archedMomentoBlack3,
      PHOTOS.archedMomentoBlack6,
      PHOTOS.archedMomentoBrushedGold4,
      PHOTOS.archedMomentoOlive4,
      PHOTOS.archedMomentoMocha4,
    ],
    highlights: [
      "2 · 3 · 4 · 5 · 6 · 12 · 14 coin configurations",
      "Five silhouettes — Classic, Twin, Circular, Temple, Tall Vertical",
      "99.9 silver photo coins with CZ stone rings",
      "Four frame finishes to match the occasion",
    ],
    options: {
      silhouette: [
        "Classic Arch",
        "Twin Arch (2 coins)",
        "Circular Family (12+)",
        "Temple Dome",
        "Tall Vertical",
      ],
      coinCount: ["2 Coins", "3 Coins", "4 Coins", "5 Coins", "6 Coins", "12 Coins", "14 Coins"],
      frameFinish: [
        "Piano Black",
        "Brushed Gold",
        "Olive Champagne",
        "Mocha Bronze",
      ],
    },
    fields: {
      photo: true,
      baseMessage: { label: "Message engraved on the base (max 24 words)", maxWords: 24 },
    },
  },
  {
    id: "gold-locket-engraved-10g",
    name: "Photo Engraved Gold Locket Pendant (5gr – 10gr)",
    tag: "22ct Gold · 30×26 mm · CZ Halo",
    productType: "locket",
    productTypeLabel: "Gold Locket",
    designType: "wearable-cz-halo-locket",
    designLabel: "Wearable CZ-Halo Pendant",
    weights: ["10g"],
    blurb:
      "A wearable 22-carat, 10-gram gold locket engraved with your photograph and haloed by a shimmering ring of cubic zirconia stones. Available in four classic pendant shapes — Heart, Oval, Shield and Round — measuring 30 × 26 mm, and finished with a gold bail ready for any chain.",
    image: PHOTOS.goldLocketHeartCoupleGold,
    secondaryImage: PHOTOS.goldLocketOvalCoupleGold,
    gallery: [
      // Refreshed Product 6 gallery (per user request)
      PHOTOS.goldLocketShieldWoman,
      PHOTOS.goldLocketOvalBoy,
      PHOTOS.goldLocketOvalCoupleGold,
      PHOTOS.goldLocketOvalMustacheChain,
      PHOTOS.goldLocketHeartCoupleGold,
      PHOTOS.goldLocketRoundWomanGold,
    ],
    highlights: [
      "22ct gold · 10 g · 30 × 26 mm",
      "Photo engraving with CZ stone halo",
      "Four shapes — Heart, Oval, Shield, Round",
      "Wearable pendant with a ready gold bail",
    ],
    options: {
      shape: ["Heart", "Oval", "Shield", "Round"],
      purity: ["22ct Gold"],
    },
    fields: {
      photo: true,
      engravingText: { label: "Engraving text or initials (max 6 words)", maxWords: 6 },
    },
  },
  {
    id: "silver-plate-momento-100g",
    name: "Silver Plate Momento (30gr – 100gr)",
    tag: "925 Silver Plate · Dome Acrylic Vault",
    productType: "plate",
    productTypeLabel: "Silver Plate",
    designType: "dome-acrylic-vault-plate",
    designLabel: "Dome Acrylic Vault · Floral Silver Plate",
    weights: ["100g"],
    blurb:
      "A regal 100-gram silver plate momento — a 200 × 140 mm oval silver plate, hand-embossed with an ornate floral border and printed edge-to-edge with your full-colour photograph. Sealed inside a 180 × 230 × 60 mm dome-topped moulded acrylic display box on a velvet-lined base, and finished with a five-word engraved plaque on both the front and the back.",
    image: PHOTOS.silverPlateMomentoCoupleBearded,
    secondaryImage: PHOTOS.silverPlateMomentoCoupleRetro,
    gallery: [
      // Batch A — replace-set silver plate momento
      PHOTOS.silverPlateMomentoCoupleBearded,
      PHOTOS.silverPlateMomentoCoupleRetro,
      PHOTOS.silverPlateMomentoCoupleKanchana,
      PHOTOS.silverPlateMomentoFamilyThree,
      PHOTOS.silverPlateMomentoFamilySix,
      // Batch B — additions
      PHOTOS.silverPlateMomentoYoungCouplePink,
      PHOTOS.silverPlateMomentoThreeMen,
      PHOTOS.silverPlateMomentoBeardGlassesCouple,
      PHOTOS.silverPlateMomentoBeachCoupleNew,
      PHOTOS.silverPlateMomentoYellowSaree,
      // Batch C — additions (boxing champion, 25th anniv hearts, 50th birthday)
      PHOTOS.silverPlateMomentoBoxingChampion,
      PHOTOS.silverPlateMomento25thHeartsNew,
      PHOTOS.silverPlateMomento50thBirthdayNew,
    ],
    highlights: [
      "100 g silver plate · 200 × 140 mm oval",
      "Ornate hand-embossed floral border",
      "Dome-topped acrylic vault · 180 × 230 × 60 mm",
      "Five-word engraving on front and back plaques",
    ],
    options: {
      base: ["Velvet Black", "Velvet Navy"],
      plateShape: ["Oval 200 × 140 mm"],
    },
    fields: {
      photo: true,
      frontMessage: { label: "Front plaque engraving (max 5 words)", maxWords: 5 },
      backMessage: { label: "Back plaque engraving (max 5 words)", maxWords: 5 },
    },
  },
  {
    id: "silver-square-photo-coin-tombstone",
    name: "Photo Engraved on Square Silver Coin (10gr – 20gr)",
    tag: "99.9 Silver · Square Coin · 10g / 20g",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "square-tombstone-plaque",
    designLabel: "Square Coin · Tombstone Plaque",
    weights: ["10g", "20g"],
    blurb:
      "A 99.9 fine silver square photo coin, engraved with your photograph and haloed by two rows of shimmering cubic zirconia stones. Mounted on a dome-topped black acrylic tombstone plaque (110 × 70 × 9 mm) — with up to four words engraved on the coin's back and eight words along the base of the frame. Available in a 10 g / 30 mm coin or a larger 20 g / 37 mm coin.",
    image: PHOTOS.birthdaySilverPlateOvalRef,
    secondaryImage: PHOTOS.silverSquareTombstoneBirthdaySir,
    gallery: [
      PHOTOS.birthdaySilverPlateOvalRef,
      PHOTOS.silverSquareTombstoneBirthdaySir,
      PHOTOS.silverSquareTombstoneNewAbode,
      PHOTOS.silverSquareTombstoneHappyBirthday,
      PHOTOS.silverSquareTombstoneDiva25,
      PHOTOS.silverSquareTombstoneHarshPrachi,
    ],
    highlights: [
      "10 g / 30 mm  ·  20 g / 37 mm square coin",
      "99.9 fine silver · double CZ stone halo",
      "Dome-topped black acrylic tombstone plaque",
      "4 words on coin back · 8 words on frame",
    ],
    options: {
      weight: ["10g · 30 mm", "20g · 37 mm"],
      frame: ["Black Acrylic Tombstone · 110×70×9 mm"],
    },
    fields: {
      photo: true,
      coinBackText: { label: "Coin back engraving (max 4 words)", maxWords: 4 },
      frameText: { label: "Frame engraving (max 8 words)", maxWords: 8 },
    },
  },
  {
    id: "silver-photo-coin-100g-grand-tombstone",
    name: "Photo Engraved Silver Coin with Acrylic Framework (100gr)",
    tag: "99.9 Silver · 75 mm Coin · Flower CZ",
    productType: "coin",
    productTypeLabel: "Silver Coin",
    designType: "grand-tombstone-flower-cz",
    designLabel: "Grand Tombstone · Flower CZ",
    weights: ["100g"],
    blurb:
      "A regal 100-gram 99.9 fine silver photo coin (75 mm) engraved with your photograph and haloed by an ornate flower cubic-zirconia stone ring. Mounted inside a dome-topped 210 × 160 × 9 mm transparent acrylic tombstone plaque — with up to ten words engraved on the coin's back and ten words along the base of the frame. The showpiece of the collection.",
    image: PHOTOS.silverCoin100gFinecabPortrait,
    secondaryImage: PHOTOS.silverCoin100gKediaWedding,
    gallery: [
      // Current set — removed duplicate Finecab turban couple (was Design 04, same engraving as Design 01)
      PHOTOS.silverCoin100gFinecabPortrait,
      PHOTOS.silverCoin100gKediaWedding,
      PHOTOS.silverCoin100gKCR,
      PHOTOS.silverCoin100gElder,
      // Appended — Sharda logo, Prema Manihar portrait, IPS Iron Man, Loya Family compliments
      PHOTOS.silverCoin100gSharda,
      PHOTOS.silverCoin100gPremaManihar,
      PHOTOS.silverCoin100gIronMan,
      PHOTOS.silverCoin100gLoyaFamily,
    ],
    highlights: [
      "100 g · 99.9 fine silver · 75 mm coin",
      "Ornate flower cubic zirconia stone ring",
      "Dome-topped 210 × 160 × 9 mm acrylic plaque",
      "10 words on coin back · 10 words on frame",
    ],
    options: {
      weight: ["100g · 75mm"],
      frame: ["Black Acrylic Tombstone · 210×160×9 mm"],
    },
    fields: {
      photo: true,
      coinBackText: { label: "Coin back engraving (max 10 words)", maxWords: 10 },
      frameText: { label: "Frame engraving (max 10 words)", maxWords: 10 },
    },
  },
  {
    id: "gold-nameplate-stretch-bracelet",
    name: "Designer Stretchable Gold Bracelets",
    tag: "18ct Gold · Daily Wear · Rolex-Style",
    productType: "bracelet",
    productTypeLabel: "Bracelet",
    designType: "stretch-belt-nameplate",
    designLabel: "Stretch Belt · Gold Nameplate",
    weights: ["1g", "2g", "3g", "5g", "7g", "10g"],
    blurb:
      "Imported mesh and Rolex-style stretchable belt bracelets — comfortable daily-wear stainless-steel belts fitted with a personalised 18 ct gold ID plate, initials, name or sacred symbol (with optional cubic zirconia detailing). Gold weight ranges from 1 g up to 10 g, and the belt comes in Black, Midnight Blue, Brown, Purple and full 18 ct Gold.",
    image: PHOTOS.birthdayBraceletInitialsRef,
    secondaryImage: PHOTOS.goldStretchBraceletMJDWide,
    gallery: [
      PHOTOS.birthdayBraceletInitialsRef,
      // Refreshed Product 9 gallery (per user request)
      PHOTOS.goldStretchBraceletSMASPMesh,
      PHOTOS.goldStretchBraceletOrnateMonograms,
      PHOTOS.goldStretchBraceletMRASRKStack,
      PHOTOS.goldStretchBraceletReligiousMotifs,
      PHOTOS.goldStretchBraceletMJDWide,
      // Batch B — additions
      PHOTOS.goldStretchBraceletVirajNavy,
      PHOTOS.goldStretchBraceletBlueKAKLK,
      PHOTOS.goldStretchBraceletMohitShield,
      PHOTOS.goldStretchBraceletBrownATwoMesh,
      PHOTOS.goldStretchBraceletRoseGoldChevron,
      // Batch C — additions
      PHOTOS.goldStretchBraceletChocHeartKnot,
      PHOTOS.goldStretchBraceletGoldNCircle,
      PHOTOS.goldStretchBraceletBlackROrnate,
      PHOTOS.goldStretchBraceletFiveMeshStack,
      PHOTOS.goldStretchBraceletDiamondShields,
      // Batch D — additions
      PHOTOS.goldStretchBraceletMRAASRKSeven,
      PHOTOS.goldStretchBraceletBrownMSDS,
      PHOTOS.goldStretchBraceletOmNavyCZ,
      PHOTOS.goldStretchBraceletGoldMeshCZFour,
    ],
    highlights: [
      "18 ct gold nameplate · 1 g – 10 g range",
      "Imported mesh or Rolex-style stretch belt",
      "Name · Initials · Sacred symbol · CZ optional",
      "Comfortable everyday wear · stretch fit",
    ],
    options: {
      goldWeight: ["1g", "2g", "3g", "5g", "7g", "10g"],
      beltStyle: ["Rolex Stretch", "Milanese Mesh"],
      beltColour: ["Black", "Midnight Blue", "Brown", "Purple", "18ct Gold"],
    },
    fields: {
      photo: false,
      nameOrInitials: { label: "Name, initials or symbol (max 6 characters)", maxWords: 6 },
    },
  },
];

// ---- Product display order (bracelets first, then coins by weight ascending, then customised frames) ----
// This order is a fixed business rule and applies wherever products are rendered.
// Lockets are placed just before the customised-frames bucket — flag with the user if a
// different position is preferred.
const PRODUCT_DISPLAY_ORDER = {
  "gold-nameplate-stretch-bracelet": 10,       // Bracelets
  "silver-plate-momento-100g": 20,             // Silver Plate Momento
  "silver-photo-coin-5g-float": 30,            // 5g coins (floating frame)
  "silver-photo-coin-10g": 40,                 // 10g coins (compact frame)
  "silver-square-photo-coin-tombstone": 45,    // 10–20g coins (square)
  "silver-photo-coin-30g": 60,                 // 30g coins (piano-black stand)
  "silver-photo-coin-51mm": 65,                // 30g coins (51mm acrylic)
  "silver-photo-coin-100g-grand-tombstone": 70,// 100g coins
  "gold-locket-engraved-10g": 80,              // Locket (placement to be confirmed)
  "arched-multi-coin-momento": 90,             // Customised / arched frames
};

// Apply the sort in-place — the exported array now reflects business order.
PERSONALIZED_PRODUCTS.sort(
  (a, b) => (PRODUCT_DISPLAY_ORDER[a.id] ?? 999) - (PRODUCT_DISPLAY_ORDER[b.id] ?? 999)
);
export const CATALOG_CATEGORIES = [
  "All",
  "Rings",
  "Necklaces",
  "Earrings",
  "Bangles",
  "Pendants",
  "Chains",
  "Other",
];

// Curated "Shop by Occasion" mapping — hand-mapped to existing productType
// values (coin / momento / locket / plate / bracelet) rather than adding a
// new per-product schema field, since the current 10-product catalog maps
// cleanly onto a handful of occasions already. Used by ShopByOccasionSection
// (homepage) and CatalogSection's `?occasion=` filter.
export const CATALOG_OCCASIONS = [
  {
    slug: "birthday",
    label: "Birthday",
    description: "A photo coin, locket or nameplate bracelet engraved just for their special day.",
    productTypes: ["coin", "bracelet", "locket"],
    image: PHOTOS.birthdayTombstoneVedaantRef,
  },
  {
    slug: "anniversary",
    label: "Anniversary",
    description: "Hand-engraved coins, lockets and plates that capture milestones worth celebrating.",
    productTypes: ["coin", "locket", "plate"],
    image: PHOTOS.anniversaryOvalFrameCoupleRef,
  },
  {
    slug: "achievements",
    label: "Achievements",
    description: "Personalised plaques and mementos for promotions, awards and recognition moments.",
    productTypes: ["plate", "momento", "coin"],
    image: PHOTOS.achievementsIronManTrophyRef,
  },
  {
    slug: "wedding",
    label: "Wedding Gifts",
    description: "Timeless engraved coins, lockets and momentos for the couple's big day.",
    productTypes: ["coin", "locket", "momento"],
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/ioxbyyre_WhatsApp%20Image%202026-07-30%20at%2015.37.47.jpeg",
  },
  {
    slug: "corporate",
    label: "Corporate Gifts",
    description: "Bulk-ready plates, momentos and coins personalised with your brand or team.",
    productTypes: ["plate", "momento", "coin"],
    image:
      "https://customer-assets-4nw71qhi.emergentagent.net/job_glass-jewels/artifacts/j5i2pvo2_WhatsApp%20Image%202026-07-30%20at%2015.18.22.jpeg",
  },
];

export const ORDER_STATUSES = [
  { value: "received", label: "Received", color: "text-white" },
  { value: "in_production", label: "In Production", color: "text-[#d4af37]" },
  { value: "dispatched", label: "Dispatched", color: "text-sky-300" },
  { value: "delivered", label: "Delivered", color: "text-emerald-400" },
];

export const buildWhatsappMessage = (order) => {
  const lines = [
    `*New Custom Order — ${order.product_name}*`,
    "",
    ...Object.entries(order.customization || {})
      .filter(([, v]) => v && String(v).trim().length)
      .map(([k, v]) => `• ${labelise(k)}: ${v}`),
    "",
    `*Name:* ${order.customer_name}`,
    `*Phone:* ${order.customer_phone}`,
    `*Address:* ${order.customer_address}`,
  ];
  if (order.gift_packaging) lines.push(`*Gift Wrapping:* Yes`);
  if (order.notes) lines.push(`*Notes:* ${order.notes}`);
  lines.push("", `Order ID: ${order.id}`);
  return lines.join("\n");
};

const labelise = (k) =>
  k.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());

// Applies admin-managed image overrides (fetched from /api/catalog-images) on top
// of the built-in catalog photos. Mutates the shared PERSONALIZED_PRODUCTS / HERO_FEATURED
// arrays in place so every existing component (Hero, CatalogSection, SamplesPage,
// ConfiguratorDialog, etc.) picks up the change on next render — no per-component changes needed.
export function applyCatalogImageOverrides(imagesByProductId) {
  Object.entries(imagesByProductId || {}).forEach(([id, images]) => {
    const urls = (images || []).map((img) => img.url).filter(Boolean);
    if (!urls.length) return;
    const product = PERSONALIZED_PRODUCTS.find((p) => p.id === id);
    if (product) {
      product.image = urls[0];
      product.secondaryImage = urls[1] || urls[0];
      product.gallery = urls;
    }
    HERO_FEATURED.forEach((f) => {
      if (f.id === id) f.image = urls[0];
    });
  });
}
